import { useEffect, useState } from "react";
import { Competition, emptyCompetition } from "../../../interfaces/competition";
import { Media } from "../../../interfaces/media";
import { getCompetitionSingle } from "../../../services/competition";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../general/loading-spinner";
import { Col, Row } from "react-bootstrap";
import { t } from "i18next";

export function CompetitionView() {
    const params: any = useParams();

    const [media, setMedia] = useState<Media[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [competition, setCompetition] = useState<Competition>(emptyCompetition);

    useEffect(() => {
        getCompetitionSingle(params.id)
            .then(response => {
                setCompetition(response.data);
                setMedia(response.data.documents.map((m: Media) => {
                    return m;
                }));
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);
    
    return (
        <div className="competition-view-container"> 
            <div className="inner">
            { !loaded && 
                <LoadingSpinner />
            }
            { loaded && 
                <h1>{ competition.name }</h1>
            }
            { loaded &&
                <div className="competitions-view">
                    <Row>
                        <Col xs={12} lg={6}>
                            <div className="competition-data">
                                { competition.description.length > 0 &&
                                    <div className="description">
                                        { competition.description }
                                    </div>
                                }
                                { competition.date_description.length > 0 &&
                                    <div className="date-description">
                                        <i className="bi bi-calendar-check"></i> { competition.date_description }
                                    </div>
                                }
                                { competition.venue_name.length > 0 &&
                                    <div className="venue">
                                        { competition.venue_name }
                                        { competition.venue_link.length > 0 &&
                                            <a href={ competition.venue_link } target="_blank" title={ "+ info" }>
                                                <i className="bi bi-arrow-right-circle"></i>
                                            </a>
                                        }
                                    </div>
                                }
                            </div>
                        </Col>
                        <Col xs={12} lg={6}>
                            { competition.documents.length > 0 &&
                                <div className="documents-list">
                                    <h4>{ t("Documents") }</h4>
                                    <ul>
                                        { competition.documents.map((d: Media) => {
                                            return <li>
                                                <a href={ d.url } title={ d.name } target="_blank">
                                                    { d.name }
                                                </a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                            }
                        </Col>
                    </Row>
                </div>
            }
            </div>
        </div>
    );
}